var map = {
	"./de/slogan.png": "Vzsg",
	"./en/slogan.png": "er4i",
	"./es/slogan.png": "7FKC",
	"./fr/slogan.png": "H/Ol",
	"./ja/slogan.png": "Ecbz",
	"./ko/slogan.png": "AILS",
	"./pt/slogan.png": "00k2",
	"./ru/slogan.png": "0Bts",
	"./th/slogan.png": "Vbc+",
	"./zh-Hant/slogan.png": "EKrJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CE7B";